export default class AnimalTypeService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getAnimalTypes() {
    return this.$http.get('/api/animal_type');
  }

  minimumAnimalWeight(animalType) {
    if (!animalType) {
      return 0.0;
    }

    switch (animalType) {
      case 'Horse':
        return 100.0;
      case 'Dog':
      case 'Cat':
        return 0.1;
      default:
        return 0.1;
    }
  }

  maximumAnimalWeight(animalType) {
    if (!animalType) {
      return 2500.0;
    }

    switch (animalType) {
      case 'Horse':
        return 2500.0;
      case 'Dog':
        return 200.0;
      case 'Cat':
        return 30.0;
      default:
        return 2500.0;
    }
  }
}



// WEBPACK FOOTER //
// ./services/animal-type.service.js